var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-background-container flex-box horizontally-centered vertically-centered"},[_c('div',{staticClass:"center-container modal-scroll-bar"},[_c('RemoteLogin',{on:{"login-successfully":function () { return this$1.$router.push('/dashboard'); }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }